import { render, staticRenderFns } from "./Caregiver.vue?vue&type=template&id=d7a4b4b2&scoped=true"
import script from "./Caregiver.vue?vue&type=script&lang=js"
export * from "./Caregiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a4b4b2",
  null
  
)

export default component.exports